import React from 'react'

export function IconDetalis({ IconName, IconHeading, coloreIcon }) {
  return (
    <>
      <div className={coloreIcon}>
        <span className="material-icons text-2xl">{IconName}</span>
        <p>{IconHeading}</p>
      </div>
    </>
  );
}
